import type { RawImage, Image } from '../props/types/Image'
import { basicImageParser } from '../props/parsers/Image'

interface RawPartner {
  name: string
  url: string
  image: RawImage
}

export interface Raw {
  acfFcLayout: 'featured_partners'
  featuredPartners: {
    headlineText: string
    partners: RawPartner[]
  }
}

interface Partner {
  name: string
  url: string
  image: Image
}

interface Props {
  headlineText: string
  partners: Partner[]
}

export interface Parsed {
  name: 'FeaturedPartners'
  props: Props
}

export default function parser(raw: Raw): Parsed {
  const { partners, headlineText } = raw.featuredPartners

  return {
    name: 'FeaturedPartners',
    props: {
      headlineText,
      partners: partners.map((partner) => {
        const { image, name, url } = partner
        return {
          name,
          url,
          image: basicImageParser(image),
        }
      }),
    },
  }
}
